import { chakra } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export function Debug({ children }: PropsWithChildren) {
  return (
    <chakra.pre
      bg="#fbfbfb"
      border="1px solid #cecece"
      borderRadius="radius.8"
      display="inline-block"
      py="space.10"
      px="space.14"
      maxWidth="100%"
      overflow="auto"
    >
      <chakra.code fontSize="md">{JSON.stringify(children, undefined, 2)}</chakra.code>
    </chakra.pre>
  );
}
